import { Call, ApiUrl, ParseGeneralResponse } from './ApiUtils';

export const VENDOR_STEPS = {
  company_assignment: 'review',
  intro: 'company_assignment',
  review: 'vendor_welcome',
  vendor_training_video: 'completed',
  vendor_welcome: 'completed'
};

export function setOnBoardStep (step) {
  const url = ApiUrl('/users/on_board_step');

  return Call(
    'put',
    url,
    { step },
    ParseGeneralResponse,
    {
      responseDataKeys: { step: 'step' },
    },
  );
}

export const getUser = id => {
  const url = ApiUrl(`/users/${id}`);

  return Call('get', url, {}, ParseGeneralResponse, {
    responseDataKeys: { user: 'user' },
  });
};

export function saveUser (isNew, data) {
  const url = isNew ? ApiUrl('/users') : ApiUrl(`/users/${data.id}`);
  const method = isNew ? 'post' : 'put';

  return Call(method, url, data, ParseGeneralResponse, { responseDataKeys: { user: 'user' } });
}

export function fetchAdHocUsers () {
  const url = ApiUrl('/users/list_adhoc_users');

  return Call('get', url, {}, ParseGeneralResponse, { responseDataKeys: { users: 'users' } });
}

export function updateUserProfileFields (data) {
  const url = ApiUrl('/users/update_profile_fields');

  return Call( 'post', url, data, ParseGeneralResponse);
}

export function getGlobalNewBuyerRequirements () {
  const url = ApiUrl('/global/new_buyer_requirements_checklist');

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { checklist: 'checklist' } },
  );
}

export function assignUserRole (roleId, userId) {
  const url = ApiUrl(`/users/${userId}/attach_role`);

  return Call('patch', url, { role_id: roleId }, ParseGeneralResponse);
}

export function removeUserRole (roleId, userId) {
  const url = ApiUrl(`/users/${userId}/detach_role`);

  return Call('delete', url, { role_id: roleId }, ParseGeneralResponse);
}
